module.exports = require("./es-CU.d.ts");